import { render, staticRenderFns } from "./info-item.vue?vue&type=template&id=a62acaac&scoped=true&"
import script from "./info-item.vue?vue&type=script&lang=js&"
export * from "./info-item.vue?vue&type=script&lang=js&"
import style0 from "./info-item.vue?vue&type=style&index=0&id=a62acaac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62acaac",
  null
  
)

export default component.exports